import { SxProps, Theme } from '@mui/material';

export const titleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-lg)',
	fontWeight: '800',
	color: '#333333',
	letterSpacing: '0px',
};

export const subtitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	fontWeight: 'normal',
	color: '#2C2C2C',
	letterSpacing: '0px',
};

export const containerStripSX: SxProps<Theme> = {
	backgroundColor: '#EBF9FF',
	borderRadius: '4px',
	flexDirection: 'row',
	marginBottom: '5px',
};
